export default __webpack_public_path__ + "audio/a9dd9d4f92599f30773fab2d52db6ba9-strike.wav";